import React from "react";
import { DeleteConfirmationModal } from "../../../DeleteConfirmationModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const DeleteModalWrapper: React.FC = () => {
  const { modals } = useClarificationsRegisterContext();
  const { isDeleteModalOpen, setIsDeleteModalOpen, setDeletingClarification, deletingClarification, isDeleting, handleConfirmDelete } = modals;

  return (
    <DeleteConfirmationModal
      isOpen={isDeleteModalOpen}
      onClose={() => {
        setIsDeleteModalOpen(false);
        setDeletingClarification(null);
      }}
      onConfirm={handleConfirmDelete}
      clarification={deletingClarification}
      isLoading={isDeleting}
    />
  );
};
